import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Icon ionic-md-mail-open",
  "use": "icon-Icon ionic-md-mail-open-usage",
  "viewBox": "0 0 17.029 14.597",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17.029 14.597\" id=\"icon-Icon ionic-md-mail-open\"><defs><style>#icon-Icon ionic-md-mail-open .a{fill:#fff;}</style></defs><path class=\"a\" d=\"M19.279,9.733a1.581,1.581,0,0,0-.771-1.379L10.765,4.5,3.021,8.354A1.673,1.673,0,0,0,2.25,9.733v7.742A1.626,1.626,0,0,0,3.872,19.1H17.658a1.626,1.626,0,0,0,1.622-1.622Zm-8.515,3.89L4.251,9.366l6.514-3.244,6.514,3.244Z\" transform=\"translate(-2.25 -4.5)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol